import {
  taskDetailsTranslation,
  TaskDetailsTranslation,
} from '@/assets/locales/views/tasks/details/taskDetails.translation.pl.ts';
import {
  taskDialogTranslation,
  TaskDialogTranslation,
} from '@/assets/locales/views/tasks/dialog/taskDialog.translation.pl.ts';
import {
  tasksListViewTranslation,
  TasksListViewTranslation,
} from '@/assets/locales/views/tasks/list/tasksListView.translation.pl.ts';

export type TasksTranslations = {
  details: TaskDetailsTranslation;
  dialog: TaskDialogTranslation;
  list: TasksListViewTranslation;
};

export const tasksTranslations: TasksTranslations = {
  details: taskDetailsTranslation,
  dialog: taskDialogTranslation,
  list: tasksListViewTranslation,
};
